import { render } from "./file-uploader-illustration.vue.js?vue&type=template&id=774c1638!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./file-uploader-illustration.vue?vue&type=template&id=774c1638"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__